export function saleRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SALE_START":           
        case "CREATE_REAPPRO_EXT_START":           
        case "RECEIVE_REAPPRO_START":           
        case "VALIDATE_PREPA_START":           
        case "DELETE_PREPA_START":           
        case "DELETE_REAPPRO_START":           
        case "DELETE_SALE_START":           
        case "LINK_SALES_START":           
        case "UNLINK_SALES_START":           
        case "FETCH_INIT_DATA2_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_SALE_FULFILLED":           
        case "CREATE_REAPPRO_EXT_FULFILLED":           
        case "RECEIVE_REAPPRO_FULFILLED":           
        case "VALIDATE_PREPA_FULFILLED":           
        case "DELETE_PREPA_FULFILLED":           
        case "DELETE_REAPPRO_FULFILLED":           
        case "DELETE_SALE_FULFILLED":           
        case "LINK_SALES_FULFILLED":           
        case "UNLINK_SALES_FULFILLED":           
        case "FETCH_INIT_DATA2_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SALE_ERROR":
        case "CREATE_REAPPRO_EXT_ERROR":
        case "RECEIVE_REAPPRO_ERROR":
        case "VALIDATE_PREPA_ERROR":           
        case "DELETE_PREPA_ERROR":
        case "DELETE_REAPPRO_ERROR":
        case "DELETE_SALE_ERROR":
        case "LINK_SALES_ERROR":
        case "UNLINK_SALES_ERROR":
        case "FETCH_INIT_DATA2_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}